"use client"

import { useRef, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogTitle, DialogTrigger } from "../ui/dialog";
import { Trash2 } from "lucide-react";
import z from "zod";
import { CronjobSchema } from "@/schemas/cronjob.schema";
import { Button } from "../ui/button";
import { CreateStatus } from "@/constants/status";
import { dropdownCss } from "../ui/dropdown";
import { deleteCronjobEntry } from "@/services/cronjob.service";

interface Props{
    entry: z.infer<typeof CronjobSchema>,
    updatedata: () => void
}

export default function CronjobDeleteModal(props: Props){
    const [open, setOpen] = useState(false);
    const [deleteStatus, setDeleteStatus] = useState(CreateStatus.standBy);
    const [failedMessage, setFailedMessage] = useState("");

    var defaultSelectValue = props.entry.UploadsCleanup ? "UploadsCleanup" : props.entry.Rekvisition ? "Rekvisition" : props.entry.CRM_Sync ? "CRM_Sync" : props.entry.MailMergeService ? "MailMergeService" : "No value";
    const selectRef = useRef(defaultSelectValue);

    async function deleteEntry(entry: z.infer<typeof CronjobSchema>){
        const selectChoice = selectRef.current;

        const formData = new FormData();
        formData.append("domainID", entry.DomainID.toString());
        formData.append("cronType", selectChoice);
        console.log(selectChoice);
        var result = null;
        try {
            result = await deleteCronjobEntry(formData);
        }  catch (error) {
            setDeleteStatus(CreateStatus.failed);
            errorHandler(error);
        }

        if(result){
            setDeleteStatus(CreateStatus.completed);
            props.updatedata();
            setTimeout(() => {
                setOpen(false);
                setDeleteStatus(CreateStatus.standBy);
            }, 2000);
            return;
        }

        setDeleteStatus(CreateStatus.failed);
        return;
    }
    
    function errorHandler(data: any){
        console.log("Erorr occoured");
        console.log(data);
        setFailedMessage("An error occurred while creating the entry. Check console.log for more information");
    }

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            {defaultSelectValue != "No value" && (
                <DialogTrigger asChild>
                    <Trash2 color="#ff0000" cursor="pointer" strokeWidth={1.5} />
                </DialogTrigger>
            )}
            <DialogContent className="max-w-sm">
                <DialogTitle>Delete Cronjob Entry</DialogTitle>
                <DialogDescription> 
                </DialogDescription>
                <div>
                    <p>Which Cronjob do you want to delete?</p>
                    <select name="cronjobDeletePick" id="cronjobDeletePick" className={dropdownCss} onChange={(e) => {
                        selectRef.current = e.target.value;
                        console.log(selectRef.current);
                    }}>
                        {props.entry.CRM_Sync && (
                            <option value="CRM_Sync">CRM Sync</option>
                        )}
                        {props.entry.Rekvisition && (
                            <option value="Rekvisition">Rekvisition</option>
                        )}
                        {props.entry.UploadsCleanup && (
                            <option value="UploadsCleanup">UploadsCleanup</option>
                        )}
                        {props.entry.MailMergeService && (
                            <option value="MailMergeService">MailMergeService</option>
                        )}
                    </select>
                </div>
                <div>
                    <Button onClick={() => deleteEntry(props.entry)}>Delete</Button>
                </div>
                <DialogFooter>
                    <div className="grid grid-cols-6 gap-4">
                        <div className="col-start-1 col-end-7 rounded-md border-black">
                            {deleteStatus == CreateStatus.onGoing && (
                                <div className="flex flex-col w-full max-w-2xl  gap-y-4">
                                    <p>Deleting Entry...</p>
                                </div>
                            )}
                            {deleteStatus == CreateStatus.completed && (
                                <div className="flex flex-col w-full max-w-2xl  gap-y-4">
                                    <p>Deleted Entry! The modal will close momentarily</p>
                                </div>
                            )}
                            {deleteStatus == CreateStatus.failed && (
                                <div className="flex flex-col w-full max-w-2xl  gap-y-4">
                                    <p>{failedMessage}</p>
                                </div>
                            )}
                        </div>
                    </div>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}